// EX- headerStore/helpers.js
// addSignedInState is now a navHeader action

import { localKillswitches } from '#shared/features/killswitches/config';

export function getKillswitchConfig(xapiResponse) {
  return { killswitches: xapiResponse?.meta?.properties, localKillswitches };
}
